import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { CREATE_JOIN_REQUEST_RESOURCE } from '../constants';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_JOIN_REQUEST_RESOURCE,
      method: 'post',
      request: (tag, body) => ({
        url: apiRoutes.communityJoinRequests(tag),
        body,
      }),
    },
  ])(ComposedComponent);
